import type { OrderDetailsOrderLine } from '@/types/orderDetailsOrder';

import { ProductType } from '@/lib/const';
import { getProductType } from '@/lib/product';

type ReturnableOrderLine = Pick<OrderDetailsOrderLine, 'variant'>;

export function isReturnableLine(orderLine: ReturnableOrderLine): boolean {
  const productType = orderLine.variant?.product?.productType;
  const slug = getProductType(productType);
  if (
    [
      ProductType.Engraving,
      ProductType.Gift,
      ProductType.ColoradoTaxDummy,
    ].includes(slug)
  ) {
    return false;
  }
  return true;
}
